import axios from 'axios';
import { createAuthInterceptor } from '@platform/auth-sdk';
import { ApiError } from '@/types/api';
import type { ApiResponse } from '@/types/api';

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth interceptor — attaches Bearer token and handles 401 refresh/retry
createAuthInterceptor(apiClient, {
  identityCenterUrl: import.meta.env.VITE_IDENTITY_CENTER_URL as string,
  onAuthFailure: () => {
    window.location.href = '/';
  },
});

// Response interceptor — unwrap API envelope and format errors
apiClient.interceptors.response.use(
  (response) => {
    const envelope = response.data as ApiResponse<unknown>;
    if (envelope && envelope.status === 'success') {
      response.data = envelope.data;
    }
    return response;
  },
  (error) => {
    if (axios.isAxiosError(error) && error.response) {
      const envelope = error.response.data as ApiResponse<unknown> | undefined;
      const statusCode = error.response.status;
      const message = envelope?.message || error.message || 'An unexpected error occurred';
      const fieldErrors = envelope?.errors || [];

      throw new ApiError(statusCode, message, fieldErrors);
    }
    throw error;
  },
);

export default apiClient;
